'use client';

import { LOCAL_STORAGE_KEY } from '@/shared/consts/local-storage.key';
import { useRouterWrapper } from '@/shared/hooks/use-router-wrapper';
import { useEffect, useState } from 'react';
import { SignInResponse } from '../query/use-sign-in';

export function useUserInfo() {
  const router = useRouterWrapper();
  const [userInfo, setUserInfo] = useState<SignInResponse | null>();

  const handleSetUserInfo = (params: SignInResponse) => {
    setUserInfo(params);
    localStorage.setItem(LOCAL_STORAGE_KEY.USER_INFO, JSON.stringify(params));
  };

  useEffect(() => {
    if (userInfo === undefined) {
      try {
        const raw = localStorage.getItem(LOCAL_STORAGE_KEY.USER_INFO);
        const parsed = raw ? (JSON.parse(raw) as SignInResponse) : null;
        setUserInfo(parsed);
      } catch {
        setUserInfo(null);
      }
    }
  }, [router, userInfo]);

  return { userInfo, setUserInfo: handleSetUserInfo };
}
